<template>
  <div>
    <!-- <custom-header title="权限管理" >
    </custom-header> -->
    <tk-flex  between >
      <public-header :title="title || ''" show-back></public-header>
      <a-button type="primary" @click="save" >
        保存
      </a-button>
    </tk-flex>
    <a-spin :spinning="loading">
      <div class="full-width p-20 bg-white border-radius-12" >
        <ak-permissions v-model="permissions" :type="type" />
      </div>
    </a-spin>
  </div>
</template>
<script>
import publicHeader from '../../components/publicHeader.vue'

export default {
  components: {
    publicHeader
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      role: {},
      title: '',
      permissions: [],
      type: '' // 留空代表不限
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    onSelect (selectedKeys, info) {
      // console.log('selected', selectedKeys, info)
      this.current = selectedKeys
      // console.log(this.current)
    },
    // 初始化菜单按钮
    async init () {
      try {
        console.log(this.$route.query)
        let classes = this.$route.query.type === 'admin' ? '_User' : 'department'
        const { data } = await this.$tkParse.get(`/classes/${classes}/${this.$route.query.id}`)
        console.log(data)
        this.role = data
        this.title = this.$route.query.type === 'admin' ? data.nickName : data.name
        this.permissions = data.authority
        this.type = this.$route.query.type === 'admin' ? 'admin' : `level${data.level}`
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    save () {
      console.log(this.permissions)
      let classes = this.$route.query.type === 'admin' ? '_User' : 'department'
      this.$tkParse.put(`/classes/${classes}/${this.$route.query.id}`, {
        authority: this.permissions
      }).then(res => {
        console.log(res)
        // 设置用户权限
        // this.setUserPermissions(this.permissions)
        this.$notification.success({
          message: '成功',
          description: '保存成功！'
        })
      }).catch(e => {
        console.log(e)
        this.$notification.error({
          message: '失败',
          description: '保存失败，请刷新重试！'
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .permission-group-title{
    font-size: 14px;
    font-weight: bold;
  }
  .ant-checkbox-wrapper{
    color: #363B45;
    font-size: 12px;
  }
  .permission-group-title .group-title-icon{
    width: 2px;
    height: 12px;
    margin-right: 4px;
    margin-top: -2px;
  }
}
</style>
